/**@jsx jsx */
import { jsx, Flex } from "theme-ui";

const MasterDisclaimer = () => {
  return (
    <Flex
      sx={{
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <small
        sx={{
          p: {
            variant: "text.disclaimerText",
            mb: "12px",
          },
        }}
      >
        <p>
          © {new Date().getFullYear()} First Virginia Financial Services, LLC.
          All Rights Reserved.
        </p>
        <p>
          <b>Customer Notice:</b> There are a wide variety of financial products
          available in the marketplace, so your choice should match your
          financial needs. Small-dollar loans used over a long period of time
          can be expensive.
        </p>
        <p>
          <b>Noticia al Consumidor:</b> Existe una amplia variedad de productos
          financieros disponibles en el mercado, por lo que su elección debe
          coincidir con sus necesidades financieras. Los préstamos de poco
          dinero utilizados durante un largo período de tiempo pueden ser
          costosos.
        </p>
        <p>
          <b>Green Dot:</b> must be 18 or older to open an account. Online
          access, mobile number verification (via text message) and identity
          verification (including SSN) are required to open and use your
          account. Mobile number verification, email address verification and
          mobile app are required to access all features. 1.Early direct deposit
          availability depends on payor type, timing, payment instructions, and
          bank fraud prevention measures. As such, early direct deposit
          availability may vary from pay period to pay period. The name and
          Social Security number on file with your employer or benefits provider
          must match your Green Dot account to prevent fraud restrictions on the
          account. 2.Opt-in required. Account must be in good standing and
          chip-enabled debit card activated to opt-in. Initial and ongoing
          eligible direct deposits are required for overdraft coverage.
          Additional criteria may apply which can affect your eligibility and
          your overdraft coverage. Overdrafts are paid at our discretion.
          Overdraft fees may cause your account to be overdrawn by an amount
          that is greater than your overdraft coverage. A $15 fee may apply to
          each eligible purchase transaction that brings your account negative.
          Balance must be brought to at least $0 within 24 hours of
          authorization of the first transaction that overdraws your account to
          avoid a fee. 3.See app for free ATM locations. 1 free in-network
          withdrawal per calendar month. $3.00 per withdrawal thereafter. $3.00
          for out-of-network withdrawals and $1.00 for balance inquiries, plus
          any fee the ATM owner may charge. Limits apply. Green Dot® cards are
          issued by Green Dot Bank, Member FDIC, pursuant to a license from Visa
          U.S.A., Inc. Visa is a registered trademark of Visa International
          Service Association. And by Mastercard International Inc. Mastercard
          and the circles design are registered trademarks of Mastercard
          International Incorporated. Green Dot Bank also operates under the
          following registered trade names: GO2bank, GoBank and Bonneville Bank.
          All of these registered trade names are used by, and refer to, a
          single FDIC-insured bank, Green Dot Bank. Deposits under any of these
          trade names are deposits with Green Dot Bank and are aggregated for
          deposit insurance coverage up to the allowable limits. ©2023 Green Dot
          Bank. All rights reserved. Green Dot Corporation NMLS #914924; Green
          Dot Bank NMLS #908739
        </p>
        <p>
          Check cashing services performed by Buckeye Check Cashing of Virginia,
          Inc.
        </p>
        <p>
          The USA PATRIOT Act is a Federal law that requires all financial
          institutions to obtain, verify, and record information that identifies
          each person who opens an account. You will be asked to provide your
          name, address, date of birth, and other information that will allow us
          to identify you. You may also be asked to provide documentation as
          proof of identification. Approval is contingent upon successfully
          passing this mandatory identification confirmation.
        </p>
        <p>
          Third party lending products available. Not all consumers may qualify;
          certain restrictions apply. See store for details.
        </p>
      </small>
    </Flex>
  );
};

export default MasterDisclaimer;
